<template>
  <div class="subscriptionModalHeader">
    <CofocusLogo :isSubscription="true" />
    <div class="subscriptionModalHeader--close" @click="closeModal">
      <button>
        <IconClose />
      </button>
    </div>
  </div>
</template>

<script>
import CofocusLogo from "../Nav/CofocusLogo.vue";
import IconClose from "../../ELYXIcons/IconClose.vue";

export default {
  components: {
    CofocusLogo,
    IconClose,
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style>
.subscriptionModalHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0px;
  position: relative;
}
.subscriptionModalHeader--close {
  border-radius: 360px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -3px;
  top: -1px;
  box-sizing: border-box;
  padding: 2.5px;
  filter: opacity(0.5);
}
.subscriptionModalHeader--close:hover {
  background-color: #f5f5f5;
  filter: unset !important;
}

.subscriptionModalHeader--close button {
  background-color: transparent;
  border: none;
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

/* For some reason, Firefox displays the icons bigger than other browsers */
@supports (-moz-appearance: none) {
  .subscriptionModalHeader--close button {
    width: 20px;
    height: 20px;
  }
}
</style>
